/**
 * @typedef {Readonly<{ allowedRoles: string[], auth: { roles: string[] }, children?: React.ReactNode }>} Props
 * @typedef {Readonly<{ allowedRoles: string[], children?: React.ReactNode }>} PublicProps
 */

import { withAuth } from 'shared/AuthProvider';
import React from 'react';

/** @extends {React.Component<Props>} */
export class RoleGate extends React.Component {
	userHasRole() {
		return this.props.allowedRoles.some((role) =>
			this.props.auth.roles.includes(role)
		);
	}

	render() {
		if (!this.userHasRole()) {
			return null;
		}

		return this.props.children;
	}
}

export default /** @type {React.ComponentType<PublicProps>} */ (
	/** @type {(component: React.ComponentType<Props>) => React.ComponentType<PublicProps>} */ (
		/** @type {unknown} */ (withAuth)
	)(RoleGate)
);
